import axios from 'axios';
const auth = axios.create({baseURL:'http://realitycygars.ddns.net:9001'});
export default auth;